export enum AssetUploadErrorType {
  UNSUPPORTED_MEDIA_FORMAT = 'unsupportedMediaFormat',
  MAX_FILE_SIZE_EXCEEDED = 'maxFileSizeExceeded',
  INVALID_DURATION = 'invalidDuration',
  AUDIO_PROCESSING_FAILED = 'audioProcessingFailed',
  ASSET_TYPE_NOT_SUPPORTED = 'assetTypeNotSupported',
  STORAGE_LIMIT_EXCEEDED = 'storageLimitExceeded',
  TIME_LIMIT_EXCEEDED = 'timeLimitExceeded',
  GENERIC_UPLOAD_ERROR = 'genericUploadError'
}

export type UploadErrorDetail = {
  assetName: string;
  errorType: AssetUploadErrorType;
};

export type UploadSummary = {
  uploadedCount: number;
  failedCount: number;
  totalCount: number;
  errors: UploadErrorDetail[];
};
